import axios from 'axios'
import { sdk } from './sdk'
import { parseJwt } from '../utils/jwt'

export const getBaseUrl = (): string => {
  switch (process.env.REACT_APP_STAGE) {
    case 'dev':
      return 'api-dev.sistemiv.com'
    case 'test':
      return 'api-test.sistemiv.com'
    case 'staging':
      return 'api-staging.sistemiv.com'
    default:
      return 'api.sistemiv.com'
  }
}

const fetchSession = async () => {
  const { data: session } = await sdk.toSession({
    tokenizeAs: 'sistemiv-dev',
  })
  localStorage.setItem('access_token', session.tokenized || '')
  return session.tokenized || ''
}

export const getSIdentityUrl = (): string => {
  if (process.env.REACT_APP_S_IDENTITY_ORIGIN) {
    return process.env.REACT_APP_S_IDENTITY_ORIGIN
  }
  return 'https://account.sistemiv.com'
}

export function getCookie(name: string) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift()
}

export const imageBase = `https://${getBaseUrl()}/iam/api/profile/picture`

const axiosInstance = axios.create({
  baseURL: `https://${getBaseUrl()}/iam/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

const axiosMgmtInstance = axios.create({
  baseURL: `https://${getBaseUrl()}/spro-mgmt/api`,
})

const axiosExpressionInstance = axios.create({
  baseURL: `https://${getBaseUrl()}/s-expression-engine/api`,
})

const axiosMeteringInstance = axios.create({
  baseURL: `https://${getBaseUrl()}/s-metering-resources/api`,
})

const axiosAnalyticsInstance = axios.create({
  baseURL: `https://${getBaseUrl()}/s-analytics/api`,
})

const axiosConnectorsInstance = axios.create({
  baseURL: `https://${getBaseUrl()}/s-on-premise/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

const authInterceptor = async (config: any) => {
  let token = localStorage.getItem('access_token')
  if (!token) {
    try {
      token = await fetchSession()
    } catch (error) {
      window.location.href = `${getSIdentityUrl()}/login?return_to=${window.location.origin}?env=${
        process.env.REACT_APP_STAGE
      }`
      return Promise.reject(error)
    }
  } else {
    const jwtExpiresAt = parseJwt(token)?.exp
    const expiresAt = new Date(jwtExpiresAt * 1000)
    const now = new Date()
    if (expiresAt < now) {
      try {
        token = await fetchSession()
      } catch (error) {
        window.location.href = `${getSIdentityUrl()}/login?return_to=${window.location.origin}?env=${
          process.env.REACT_APP_STAGE
        }`
        return Promise.reject(error)
      }
    }
  }
  if (config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

axiosInstance.interceptors.request.use(authInterceptor, (error) => Promise.reject(error))
axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response && [301, 302].includes(error.response.status)) {
      const redirectUrl = error.response.headers.location
      window.location.replace(redirectUrl)
    } else {
      return Promise.reject(error)
    }
  },
)
axiosConnectorsInstance.interceptors.request.use(authInterceptor, (error) => Promise.reject(error))
axiosMgmtInstance.interceptors.request.use(authInterceptor, (error) => Promise.reject(error))
axiosExpressionInstance.interceptors.request.use(authInterceptor, (error) => Promise.reject(error))
axiosMeteringInstance.interceptors.request.use(authInterceptor, (error) => Promise.reject(error))
axiosAnalyticsInstance.interceptors.request.use(authInterceptor, (error) => Promise.reject(error))

export default axiosInstance
export {
  axiosConnectorsInstance,
  axiosMgmtInstance,
  axiosMeteringInstance,
  axiosAnalyticsInstance,
  axiosExpressionInstance,
}
